"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./business"));



//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib/dist/index.js
// module id = 133
// module chunks = 0